import MUICircularProgress from '@mui/material/CircularProgress'
import { styled } from '@mui/material/styles'

const StyledCircularProgress = styled(MUICircularProgress)({
  color: 'var(--accent)',
})

export const CircularProgress = StyledCircularProgress
